/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerFeedMill } from '../../models/customer-feed-mill';

export interface FindByName$Params {
  name: string;
}

export function findByName(http: HttpClient, rootUrl: string, params: FindByName$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerFeedMill>>> {
  const rb = new RequestBuilder(rootUrl, findByName.PATH, 'get');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerFeedMill>>;
    })
  );
}

findByName.PATH = '/api/customer/feedMill/name/{name}';
